import { ActionContext, Module } from 'vuex'
import {
  getToken,
  saveToken,
  removeToken,
  getApiAuthToken,
  revokeToken,
  shouldRevokeToken,
} from '@/utils/token'
import { RootState } from '@/store'

const state: SessionState = {
  token: getToken(),
}

export interface SessionState {
  token: string | null | undefined
  isLoggedIn?: boolean
}
type ModuleActionContext = ActionContext<SessionState, {}>

// getters
const getters = {
  isLoggedIn: (state: SessionState) => {
    return !!state.token
  },
}

const actions = {
  setToken({ commit }: ModuleActionContext, token: string | null) {
    commit('setToken', token)
  },
  logout({ commit }: ModuleActionContext) {
    commit('deleteToken')
  },
  logoutExpired({ commit }: ModuleActionContext, errorCode?: number) {
    commit('deleteExpiredToken', errorCode)
  },
}

const mutations = {
  setToken(state: SessionState, token: string | null) {
    if (token) {
      state.token = token
      state.isLoggedIn = true
      saveToken(token)
    }
  },
  deleteToken(state: SessionState) {
    // 先にweb sessionを消す
    removeToken()
    // アプリからトークンを渡されているときはログアウトにしたくないので、再度入れ直す
    // webの場合はtokenを消しているのでnull
    state.token = getToken() || undefined
    // tokenがアプリから再セットされていればtrueになり、ログイン継続
    state.isLoggedIn = !!state.token
  },
  deleteExpiredToken(state: SessionState, errorCode?: number) {
    // 401 -> /login -> /mypage -> 401 の無限ループにならないように、401 を受けたトークンを無効化して削除
    if (shouldRevokeToken(errorCode)) {
      // API が Authorization ヘッダーに使ったトークンを優先し、なければ state 側 (?st= 経由など) にフォールバック
      const expiredToken = getApiAuthToken() || state.token
      if (expiredToken) {
        revokeToken(expiredToken)
      }
    }

    removeToken()

    state.token = getToken() || undefined
    state.isLoggedIn = !!state.token
  },
}

const session: Module<SessionState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
export default session
